/**
 * @description Various modal names used in the enterprise modal manager.
 */
export const ENTERPRISE_MODAL_NAMES = {
  PROGRAM_ACCESS: 'PROGRAM_ACCESS',
  LOGIN: 'LOGIN',
  PRODUCT_DESCRIPTION_PAGE_REDIRECT: 'PRODUCT_DESCRIPTION_PAGE_REDIRECT',
  AUTOENROLLED_COURSES: 'AUTOENROLLED_COURSES',
  ADD_EMAIL: 'ADD_EMAIL',
  ENTERPRISE_TERMS_OF_USE: 'ENTERPRISE_TERMS_OF_USE',
  EMAIL_VERIFICATION: 'EMAIL_VERIFICATION',
  PROGRAM_JOIN_ERROR: 'PROGRAM_JOIN_ERROR',
  CHANGE_PREVIEW_PROGRAMS: 'CHANGE_PREVIEW_PROGRAMS',
} as const;

/**
 * Browse domain category slugs used for program-scoped → org-scoped redirect mapping.
 * Program-scoped routes serve domains at top level (/programs/:slug/:domainSlug),
 * while org-scoped routes nest them under /browse (/organizations/:orgSlug/browse/:domainSlug).
 * Subdomain segments are stripped during redirect (subdomain pages are deprecated for enterprise).
 */
export const BROWSE_CATEGORY_SLUGS = new Set([
  'arts-and-humanities',
  'business',
  'computer-science',
  'data-science',
  'information-technology',
  'health',
  'math-and-logic',
  'personal-development',
  'physical-science-and-engineering',
  'social-sciences',
  'language-learning',
]);

export enum TabName {
  Catalog = 'CATALOG',
  Recommendations = 'RECOMMENDATIONS',
  MyCourses = 'MY_COURSES',
  SkillSets = 'SKILLSETS',
  CareerAcademy = 'EXPLORE_CAREERS',
  MyLearning = 'MY_LEARNING',
}
